import React, { CSSProperties, ReactNode } from 'react';

import Typography from '@mui/material/Typography';
import { Column } from '@tanstack/react-table';

export const getCommonPinningStyles = (
  column: Column<any, unknown>,
): CSSProperties => {
  const isPinned = column?.getIsPinned();

  return {
    left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
    right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined,
    position: isPinned ? 'sticky' : 'relative',
    minWidth: column.getSize(),
    width: isPinned ? '100%' : 'auto',
    zIndex: isPinned ? 1 : 0,
  };
};

export const getCellStyles = (
  children: ReactNode | string,
  color?: string,
): ReactNode => (
  <Typography
    variant="body2"
    component="div"
    color={(theme) => color || theme.primary.p2}
  >
    {children}
  </Typography>
);
